export default "__VITE_ASSET__EA351rx0__"